import React from "react";
import { Progress } from "rbx";

const Loading = () => {
  return <Progress color="danger" />;
};

export default Loading;
